import apiClient from './apiClient';

export const adminLogin = async (email, password) => {
  try {
    const response = await apiClient.post('/admin/login', {
      email,
      password,
    });

    return response.data;
  } catch (error) {
    const message = error.response?.data?.message || 'Login failed';
    throw new Error(message);
  }
};

export const updateAdminPassword = async (password) => {
  try {
    const response = await apiClient.put('/admin/update-password', {
      password,
    });
    return response.data;
  } catch (error) {
    const message = error.response?.data?.message || 'Password update failed';
    throw new Error(message);
  }
};

export default adminLogin;
